var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95383 0.335203C1.50689 -0.111734 0.782265 -0.111734 0.335329 0.335203C-0.111608 0.782141 -0.111608 1.50677 0.335329 1.95371L4.38162 6.00001L0.335204 10.0464C-0.111735 10.4933 -0.111734 11.218 0.335204 11.6649C0.782142 12.1118 1.50677 12.1118 1.95371 11.6649L6.00012 7.61851L10.0463 11.6647C10.4933 12.1117 11.2179 12.1117 11.6648 11.6647C12.1118 11.2178 12.1118 10.4932 11.6648 10.0462L7.61863 6.00002L11.6648 1.95391C12.1117 1.50698 12.1117 0.782353 11.6648 0.335418C11.2178 -0.111518 10.4932 -0.111518 10.0462 0.335418L6.00013 4.38151L1.95383 0.335203Z",
    fill: "#ABAFBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "bc648e85be457036339bfa9737d73d71.svg";
export { ForwardRef as ReactComponent };